import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentFormLinkComponent } from './student-form-link/student-form-link.component';
import { StudentFormComponent } from './student-form/student-form.component';
import { StudentwellbeingReportComponent } from './studentwellbeing-report/studentwellbeing-report.component';
import { FacultyReferralFormComponent } from './faculty-referral-form/faculty-referral-form.component';
import { WellbeingReferralReportComponent } from './wellbeing-referral-report/wellbeing-referral-report.component';

const routes: Routes = [
  {
    path: '', component: StudentFormLinkComponent,
    children: [
      {
        path: 'studentwellbeing', component: StudentFormComponent
      },
      {
        path:'studentwellbeingReport',component:StudentwellbeingReportComponent
      },
     
      {path :'WellbieingReferal',component:FacultyReferralFormComponent},
      {path :'WellbeingReferalReport',component:WellbeingReferralReportComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentWellBeingRoutingModule { }
